import { Dialog, DialogActions, DialogContent, DialogTitle, Typography } from '@mui/material';
import PaiLink from 'features/ui/base-components/pai-link';
import _ from 'lodash';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { makeStyles } from 'tss-react/mui';
import PaiButton from '../../ui/base-components/pai-button';
import { Project } from './text-generation-project-overview';

interface Props {
  open: boolean;
  project: Project | undefined;

  handleClose(): void;

  deleteProject(projectId: string): () => void;
}

const DeleteTextGenerationProjectDialog: React.FC<Props> = ({ open, project, handleClose, deleteProject }) => {
  const { classes } = useStyles();
  const { t } = useTranslation();

  return (
    <Dialog classes={{ paper: classes.paper }} open={open} fullWidth={true} maxWidth={'xs'}>
      <DialogTitle className={classes.title}>
        <Typography className={classes.titleText}>{t('deleteProject')}</Typography>
      </DialogTitle>
      <DialogContent className={classes.content}>
        <Typography className={classes.text}>
          {t('confirmDeleteProjectText', { projectName: !_.isNil(project) ? project.projectName : '' })}
        </Typography>
      </DialogContent>
      <DialogActions className={classes.actions}>
        <PaiLink text={t('cancel')} size={'sm'} underline={'always'} action={handleClose} />
        <PaiButton text={t('ok')} action={deleteProject(project?._id || '')} />
      </DialogActions>
    </Dialog>
  );
};

const useStyles = makeStyles()((theme) => ({
  paper: {
    borderRadius: 0,
  },
  title: {
    background: theme.palette.primary.main,
  },
  titleText: {
    fontSize: theme.typography.pxToRem(15),
    fontWeight: 'bold',
    textTransform: 'uppercase',
    color: '#FFF',
    textAlign: 'center',
  },
  content: {
    padding: '20px 24px !important',
    whiteSpace: 'pre-wrap',
  },
  text: {
    fontSize: theme.typography.pxToRem(13),
    whiteSpace: 'pre-wrap',
  },
  actions: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    gap: '16px',
    padding: '0 24px 20px 24px',
  },
}));

export default DeleteTextGenerationProjectDialog;
